import { MessageCircle } from "lucide-react";
import { BRAND } from "@/lib/constants";

export const FloatingWhatsApp = () => {
  return (
    <a
      href={BRAND.whatsappLink}
      onClick={() => window.fbq && window.fbq("track", "Contact", {}, { eventID: Date.now().toString() })}
      target="_blank"
      rel="noreferrer"
      data-testid="floating-whatsapp"
      aria-label="Chat with VR Marketing Hub on WhatsApp"
      className="fixed z-[9999] bottom-28 right-6 group"
    >
      <div className="relative pulse-ring w-14 h-14 rounded-full bg-gradient-to-br from-[#25D366] to-[#128C7E] grid place-items-center shadow-[0_10px_30px_rgba(37,211,102,0.5)] hover:scale-105 transition-transform">
        <MessageCircle size={26} className="text-white" />
      </div>
      <div className="hidden md:block absolute right-16 top-1/2 -translate-y-1/2 whitespace-nowrap px-3 py-1.5 rounded-full bg-[#0A1128] border border-white/10 text-white text-xs opacity-0 group-hover:opacity-100 transition-opacity">
        Chat on WhatsApp
      </div>
    </a>
  );
};
